.loadingContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: var(--bads-color-secondary-110, #f8f9fa);
  gap: 20px;
}

.loadingContainer p {
  color: var(--bads-color-primary-120, #666);
  font-size: 16px;
  margin: 0;
}
